{
    "0DmTvgVY1kL2fqnjNw0W7": {
        "key": "0DmTvgVY1kL2fqnjNw0W7",
        "position": {
            "x": 2,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "aY_kCH003_mZZaxEDRhMF": {
        "key": "aY_kCH003_mZZaxEDRhMF",
        "position": {
            "x": 0,
            "y": 3,
            "z": 1
        },
        "maxhealth": 30,
        "affiliation": "bad",
        "jobKey": "hero/rogue"
    },
    "aJxyugpfeHtuMsroUE7mZ": {
        "key": "aJxyugpfeHtuMsroUE7mZ",
        "position": {
            "x": 4,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    }
}